// extracted by mini-css-extract-plugin
module.exports = {"list-item":"styles_list-item__o_Of1","title":"styles_title__bFF2Y","image":"styles_image__omX07","ar":"styles_ar__wKDdR"};